<template>
  <div>
    <b-modal hide-footer id="land-modal-view" size="lg" title="Land View" @hidden="onHidden">

      <div class="modal-content bg-white rounded box-shadow" v-if="Object.keys(land_list).length !== 0">
        <table class="table table-centered table-striped">
          <tr>
            <th>Land ID</th>
            <td>: {{ land_list.id }}</td>
          </tr>
          <tr>
            <th>Plot</th>
            <td>: {{ land_list.plot_no }}</td>
          </tr>
          <tr>
            <th>Mouza</th>
            <td>: {{ land_list.mouza.mouza_desc }}</td>
          </tr>
          <tr>
            <th>Land Type</th>
            <td>: {{ land_list.land_type.land_type_desc }}</td>
          </tr>
          <tr>
            <th>Land Ownership Type</th>
            <td>: {{ land_list.land_ownership_type.land_ownership_type_desc }}</td>
          </tr>
          <tr>
            <th>Acquisition (Decimal)</th>
            <td>: {{ land_list.self_acc != null ? parseFloat(land_list.self_acc).toFixed(4) : '' }}</td>
          </tr>
          <tr>
            <th>Affected (Decimal)</th>
            <td>: {{ land_list.self_affected != null ? parseFloat(land_list.self_affected).toFixed(4) : '' }}</td>
          </tr>
          <tr>
            <th>Others (Decimal)</th>
            <td>: {{ land_list.otherThan_affected != null ? parseFloat(land_list.otherThan_affected).toFixed(4) : '' }}</td>
          </tr>
          <tr>
            <th>CCL No</th>
            <td>
              : {{ land_list.ccl_land ? land_list.ccl_land.ccl.ccl_no : '' }}
              <span v-if="land_list.ccl_land && land_list.ccl_land">
                   <router-link :to="{ name: 'cclUpdate', params: { ccl_id: land_list.ccl_land.ccl.id } }" tag="a" target="_blank">
                        <span style="font-weight: 100;"> *If Update Need Click here</span>
                   </router-link>
              </span>
<!--              <a v-if="land_list.ccl_land && land_list.ccl_land" href="javascript:void(0);"-->
<!--                title="Update CCL" @click="updateCcl(land_list.ccl_land.ccl.id, land_list.id)">-->
<!--                <span style="font-weight: 100;"> *If Update Need Click here</span>-->
<!--              </a>-->
            </td>
          </tr>
          <tr>
            <th>Amount</th>
            <td>: {{ land_list.ccl_land ? land_list.ccl_land.ccl_amount : '' }}</td>
          </tr>
          <tr>
            <th>DC Surcharge</th>
            <td>: {{ land_list.ccl_land ? land_list.ccl_land.dc_surcharge ? land_list.ccl_land.dc_surcharge.percentage_surcharge :  '' : '' }}</td>
          </tr>
        </table>
      </div>
    </b-modal>
    <update-ccl-modal
        ref="updateCclModal"
        :ccl_id = "ccl_id"
    >
    </update-ccl-modal>
  </div>
</template>

<script>
import updateCclModal from '../data/ccl/modal/updateCclModal'

export default {
  name: "LandModalView",
  props: ['land_list'],
  components: {updateCclModal},
  data() {
    return {
      ccl_id :''
    };
  },

  mounted() {

  },
  methods: {
    updateCcl(ccl_id, land_id){
      if(this.land_list.id == land_id){
        // let routeData = this.$router.resolve({name: 'cclUpdate', query: {ccl_id: ccl_id}});
        // window.open(routeData.href, '_blank');

        // this.ccl_id = ccl_id
        // this.$refs.updateCclModal.onUpdate(ccl_id);
        // this.$root.$emit("bv::show::modal", "ccl-update-modal");
      }
    },
    onHidden (e) {
      this.$emit("getPersonLands");
    }
  },
};
</script>
